// extracted by mini-css-extract-plugin
export default {"recipientInfo":"PunchupRecipientInfo_recipientInfo__oUvI6","email":"PunchupRecipientInfo_email__egNra punchupTextSecondary","dateTime":"PunchupRecipientInfo_dateTime__FaHz4"};